import { useEffect, useState } from 'preact/hooks';
import useConfig from '../../../config/config.context';
import LuckyDeeplink from '../../../constants/lucky.deeplink';
import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import { renderIf } from '../../../utils/render.utils';
import BalanceControl from '../../Wallet/BalanceControl/BalanceControl';
import NotificationIcon from '../../shared/Icons/NotificationIcon';
import ProfileIcon from '../../shared/Icons/ProfileIcon';
import style from './LuckyHomeAppBar.css';
import CaasStorageKeys from '../../../constants/caas.storage.keys';
import { _className } from '../../../utils/classname.utils';
import { NotificationsFlow } from '../../../constants/notifications-flow.constant';
import NavigationUtils from '../../../utils/navigation.utils';

export default function LuckyHomeAppBar({
  className = '',
  title = '',
  showManageBalance = true,
  notificationsFlow = NotificationsFlow.NATIVE,
}) {
  const { config } = useConfig();
  const [hasNotifications, setHasNotifications] = useState(false);
  useEffect(() => {
    setHasNotifications(
      config[CaasStorageKeys.CONFIG].unread_notifications_count &&
        config[CaasStorageKeys.CONFIG].unread_notifications_count > 0,
    );
  }, [config[CaasStorageKeys.CONFIG].unread_notifications_count]);

  return (
    <div className={`${className} ${style['home-bar']}`}>
      <p className={style.title}>{title}</p>
      <div className={style.actions}>
        {renderIf(
          showManageBalance,
          <div className={style.icon}>
            <BalanceControl />
          </div>,
        )}
        <div
          className={`${style.icon} ${_className(
            hasNotifications,
            style.notification,
          )}`}
          onClick={() => {
            setHasNotifications(false);

            if (notificationsFlow === NotificationsFlow.WEBVIEW) {
              DeeplinkEvent.openWebview(
                `${NavigationUtils.Routes.NOTIFICATION_CENTER}?source=${NavigationUtils.Sources.HOME}`,
              );
            } else {
              DeeplinkEvent.open(LuckyDeeplink.NOTIFICATIONS);
            }
          }}
        >
          <NotificationIcon />
        </div>
        <div
          className={style.icon}
          onClick={() => DeeplinkEvent.open(LuckyDeeplink.ACCOUNT)}
        >
          <ProfileIcon />
        </div>
      </div>
    </div>
  );
}
